(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-testimonials-42"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mf-testimonials-42')) {
    customElements.define(
      'mf-testimonials-42',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.mf42-track');
          this.navigation = this.querySelector('.mf42-navigation');
          this.previous = this.querySelector('[data-mf42-prev]');
          this.next = this.querySelector('[data-mf42-next]');

          this.update = () => {
            const max =
              this.track.scrollWidth - this.track.clientWidth;

            const position = Math.abs(this.track.scrollLeft);

            this.navigation.hidden = max < 2;
            this.previous.disabled = position < 2;
            this.next.disabled = position >= max - 2;
          };

          this.move = direction => {
            const card = this.track.querySelector('.mf42-card');

            if (!card) return;

            const gap =
              parseFloat(
                getComputedStyle(this.track).columnGap
              ) || 0;

            const rtl =
              getComputedStyle(this.track).direction === 'rtl'
                ? -1
                : 1;

            this.track.scrollBy({
              left:
                direction *
                rtl *
                (card.getBoundingClientRect().width + gap),

              behavior: matchMedia(
                '(prefers-reduced-motion: reduce)'
              ).matches
                ? 'instant'
                : 'smooth'
            });
          };

          this.onPrevious = () => this.move(-1);
          this.onNext = () => this.move(1);

          this.onSelect = event => {
            const card = event.target.closest('.mf42-card');

            if (card && this.contains(card)) {
              card.scrollIntoView({
                block: 'nearest',
                inline: 'nearest',
                behavior: 'instant'
              });
            }
          };

          this.previous.addEventListener(
            'click',
            this.onPrevious
          );

          this.next.addEventListener(
            'click',
            this.onNext
          );

          this.track.addEventListener(
            'scroll',
            this.update,
            { passive: true }
          );

          this.addEventListener(
            'shopify:block:select',
            this.onSelect
          );

          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.track);

          this.update();
        }

        disconnectedCallback() {
          this.observer?.disconnect();

          this.previous?.removeEventListener(
            'click',
            this.onPrevious
          );

          this.next?.removeEventListener(
            'click',
            this.onNext
          );

          this.track?.removeEventListener(
            'scroll',
            this.update
          );

          this.removeEventListener(
            'shopify:block:select',
            this.onSelect
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
